import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';
import Navbar from './Navbar';
import Footer from './Footer';
import log from './services/logService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Limpa a mensagem anterior
    setIsSuccess(false);

    try {
      const response = await axios.post(`${process.env.REACT_APP_SEND_PASSWORD_RESET_URI}`, { email });

      log('Resposta completa do Axios:', response);
      log('Dados da resposta (response.data):', response.data);

      let data; // Variável para guardar o objeto { success, message } final

      // --- LÓGICA CONDICIONAL PARA ESTRUTURA DA RESPOSTA ---

      // 1. Verifica se tem a estrutura de Produção (API Gateway Proxy)
      if (response.data && typeof response.data.body === 'string') {
        try {
          data = JSON.parse(response.data.body);
        } catch (parseError) {
          log('Erro ao fazer parse do response.data.body:', parseError);
          setMessage('Erro ao processar a resposta do servidor (formato body inválido).');
          setIsSuccess(false);
          return; // Sai da função se o parse falhar
        }
      }
      // 2. Verifica se tem a estrutura Local (objeto direto)
      else if (response.data && typeof response.data.success === 'boolean') {
        data = response.data;
      }
      // 3. Se nenhuma das estruturas acima for encontrada
      else {
        log('Estrutura de resposta inesperada:', response.data);
        setMessage('Erro ao processar a resposta do servidor (formato inesperado).');
        setIsSuccess(false);
        return; // Sai da função
      }

      // --- PROCESSA O OBJETO 'data' OBTIDO ---
      log('Dados processados:', data);

      // Verifica se 'data' é válido e tem a propriedade 'success'
      if (data && typeof data.success !== 'undefined') {
        if (data.success) {
          setMessage(data.message || 'Email de recuperação enviado com sucesso!'); // Usa a mensagem do backend ou um padrão
          setIsSuccess(true);
        } else {
          // Usa a mensagem de erro do backend se existir, senão uma padrão
          setMessage(data.message || 'Falha ao enviar email de recuperação.');
          setIsSuccess(false);
        }
      } else {
        // Caso data seja inválido após as verificações (ex: parse resultou em null)
        log('Objeto de dados final inválido após processamento:', data);
        setMessage('Erro ao interpretar os dados da resposta do servidor.');
        setIsSuccess(false);
      }

    } catch (error) {
      log('Erro no handleSubmit (catch geral):', error);

      // Mantém o tratamento detalhado de erros do Axios
      if (error.response) {
        // O servidor respondeu com um status fora do range 2xx
        log('Erro - Resposta do servidor:', error.response.data);
        log('Erro - Status do servidor:', error.response.status);
        log('Erro - Cabeçalhos do servidor:', error.response.headers);

        // Tenta extrair uma mensagem de erro mais específica da resposta
        let errorMsg = `Erro do servidor: ${error.response.status}.`;
        if (error.response.data) {
            // Tenta parsear se for string (pode ser o body de erro da lambda)
            if (typeof error.response.data === 'string') {
                try {
                    const parsedErrorBody = JSON.parse(error.response.data);
                    errorMsg = parsedErrorBody.message || errorMsg;
                } catch { /* Ignora erro de parse, usa status */ }
            // Se já for objeto e tiver message
            } else if (error.response.data.message) {
                errorMsg = error.response.data.message;
            }
        }
        setMessage(`${errorMsg} Verifique o console.`);

      } else if (error.request) {
        // A requisição foi feita mas não houve resposta (CORS, rede?)
        log('Erro - Sem resposta:', error.request);
        setMessage('Erro de rede ou CORS. Verifique a conexão e a configuração do servidor.');
      } else {
        // Algo aconteceu ao configurar a requisição
        log('Erro - Configuração da requisição:', error.message);
        setMessage(`Erro ao configurar a requisição: ${error.message}`);
      }
      setIsSuccess(false); // Garante que isSuccess seja false no catch
    }
  };

  return (
    <div>
      <Navbar />
      <div className="forgot-password-container">
        <div className="logo-container">
          <img src="./logo.webp" alt="QR Code Brasil" />
        </div>
        <h1>Recuperação de Senha</h1>
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="email"
              placeholder=" " // Placeholder vazio para label flutuante
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              id="forgot-email" // ID para o label
            />
            <label htmlFor="forgot-email">Email</label> {/* htmlFor associado ao ID */}
            {/* Exibe a mensagem abaixo do input */}
            {message && (
              <div className={`message-display ${isSuccess ? 'success-message' : 'error-message'}`}>
                {message}
              </div>
            )}
          </div>
          <button type="submit">Enviar</button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
